import { ReactElement } from 'react';
import { CatHeading } from '@blocks-react/components/Heading';
import { CatIconWarningTriangle } from '@blocks-react/components/Icons/WarningTriangle';
interface MyEquipmentFooterNoteProps {
  children: ReactElement | ReactElement[] | string;
}

export const MyEquipmentFooterNote = ({
  children,
}: MyEquipmentFooterNoteProps) => {
  return (
    <>
      <CatIconWarningTriangle slot="before" className="me-1" />
      <CatHeading variant="label">{children}</CatHeading>
    </>
  );
};
